import {DIRECTIONS} from "constants/AppConstants.js";
import ConvertUtil from "utils/ConvertUtil.js";

export default class DirectionUtil {
  static getDirectionByBearing(bearing: number, isEast: boolean = false): string {
    let direction: string = "";

    if (bearing >= 338 && bearing <= 360) {
      if (isEast) {
        direction = DIRECTIONS.North;
      } else {
        direction = DIRECTIONS.N;
      }
    }

    if (bearing >= 0 && bearing <= 22) {
      if (isEast) {
        direction = DIRECTIONS.North;
      } else {
        direction = DIRECTIONS.N;
      }
    }

    if (bearing > 22 && bearing <= 66) {
      if (isEast) {
        direction = DIRECTIONS.NorthEast;
      } else {
        direction = DIRECTIONS.NE;
      }
    }

    if (bearing > 66 && bearing <= 111) {
      if (isEast) {
        direction = DIRECTIONS.East;
      } else {
        direction = DIRECTIONS.E;
      }
    }

    if (bearing > 111 && bearing <= 156) {
      if (isEast) {
        direction = DIRECTIONS.SouthEast;
      } else {
        direction = DIRECTIONS.SE;
      }
    }

    if (bearing > 156 && bearing <= 202) {
      if (isEast) {
        direction = DIRECTIONS.South;
      } else {
        direction = DIRECTIONS.S;
      }
    }

    if (bearing > 202 && bearing <= 247) {
      if (isEast) {
        direction = DIRECTIONS.SouthWest;
      } else {
        direction = DIRECTIONS.SW;
      }
    }

    if (bearing > 247 && bearing <= 292) {
      if (isEast) {
        direction = DIRECTIONS.West;
      } else {
        direction = DIRECTIONS.W;
      }
    }

    if (bearing > 292 && bearing < 338) {
      if (isEast) {
        direction = DIRECTIONS.NorthWest;
      } else {
        direction = DIRECTIONS.NW;
      }
    }

    return direction;
  }

  static getBearingValue(sLat: number, sLong: number, eLat: number, eLong: number): number {
    const startLat = ConvertUtil.convertDegreeToRadian(sLat);
    const startLong = ConvertUtil.convertDegreeToRadian(sLong);
    const endLat = ConvertUtil.convertDegreeToRadian(eLat);
    const endLong = ConvertUtil.convertDegreeToRadian(eLong);
    let dLong = endLong - startLong;
    const dPhi = Math.log(Math.tan(endLat / 2.0 + Math.PI / 4.0) / Math.tan(startLat / 2.0 + Math.PI / 4.0));
    if (Math.abs(dLong) > Math.PI) {
      if (dLong > 0.0) {
        dLong = -(2.0 * Math.PI - dLong);
      } else {
        dLong = 2.0 * Math.PI + dLong;
      }
    }

    return (ConvertUtil.convertRadianToDegree(Math.atan2(dLong, dPhi)) + 360) % 360;
  }

  static getBearing(sLat: number, sLong: number, eLat: number, eLong: number): string {
    const bearing = Math.floor(DirectionUtil.getBearingValue(sLat, sLong, eLat, eLong));
    const direction = DirectionUtil.getDirectionByBearing(bearing);

    return `${Math.floor(bearing)}°${direction}`;
  }
}
